import React from "react";

/* Component */
import About from "./About";
import Experience from "./Experience";
import Certificate from "./Certificate";
import Contact from "./Contact";
import Project from "./Project";

const Main = () => (
  <main>
    <About />

    <Experience />

    <Project />

    <Certificate />

    <Contact />
  </main>
);

export default Main;
